
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10'},
  { text: 'Fee Name', value: 'fee_name'},
  { text: 'Sales Volume/month', value: 'sales_volume', width: '300'},
  { text: 'Updated By', value: 'updated_by_username'},
  { text: 'Old Fee Sharing', value: 'old_fee_sharing'},
  { text: 'New Fee Sharing', value: 'new_fee_sharing'},
  { text: 'Last Update', value: 'updated_at'},
]);

export const search = {
  fee_name: '',
  update_by_username: '',
  old_fee_sharing: '',
  new_fee_sharing: '',
  datetime: '',
};

